<script setup>
import {useStore} from "vuex";

const store = useStore();
const props = defineProps(['type','id','title', 'position']);
defineEmits(['change']);

function changeIcon(type) {
  switch (type) {
    case 'success':
      return 'it-check-circle';
    case 'error':
      return 'it-close-circle';
    case 'info':
      return 'it-info-circle';
    case 'warning':
      return 'it-error';
    default:
      return 'it-info-circle';
  }
}
</script>
<style scoped>
.notification {
  z-index: 99999 !important;
}
</style>
<template>
  <div class="notification bottom-fix with-icon" :class="[props.type ? props.type : '', props.position ? props.position : '']" role="alert" :aria-labelledby="`${props.id}-title`" :id="`${props.id}`">
    <h2 :id="`${props.id}-title`" class="h5"><svg class="icon"><use :href="`/${store.state.modulePath}/assets/svg/sprites.svg#${changeIcon(props.type)}`"></use></svg>{{ props.title }}</h2>
    <slot></slot>
  </div>
</template>



